import React from "react";

const AppWidgetCard = ({
  title = "Cash Orders Earning",
  amount = "470.00",
  isPrice = false,
}) => {
  return (
    <div className="w-full text-left rounded-2xl bg-blue-50 px-6 py-5">
      <div className="text-sm font-medium text-gray-500">
        {title}
      </div>

      <div className="mt-1 text-5xl font-bold text-gray-900">
        {amount} {isPrice ? "AED" : ""}
      </div>
    </div>
  );
};

export default AppWidgetCard;
